import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-archived-companies-header',
  templateUrl: './archived-companies-header.component.html',
  styleUrls: ['./archived-companies-header.component.scss'],
})
export class ArchivedCompaniesHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();
}
